<template>
  <div class="upload">
    <BaseUploadImage
      accept="image/jpeg,image/png"
      multiple
      @add="onFile"
    />

    <div class="gallery">
      <div
        v-for="image of images"
        :key="image.id"
        class="gallery-item"
      >
        <div
          class="gallery-item__close"
          @click="onDeletePhoto(image)"
        >
          &#10006;
        </div>
        <AppGalleryItem
          :photo="image.url"
          class="gallery-item__photo"
        />
      </div>
    </div>

    <div class="panel">
      <BaseButton @click="onSubmit">
        Сохранить
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseUploadImage from '@/components/UploadImage'
import AppGalleryItem from '@/components/AppGalleryItem'
import BaseButton from '@/components/Base/BaseButton'

export default {
  name: 'AppPhotoUpload',
  components: {
    BaseButton,
    AppGalleryItem,
    BaseUploadImage
  },
  data () {
    return {
      images: [],
      deletedImages: []
    }
  },
  async created () {
    await this.fetchInitialImages()
  },
  methods: {
    async onSubmit () {
      this.deletedImages.forEach(id => {
        this.deleteFromBackend(id)
      })

      this.images.forEach(image => {
        if (!image.fromBackend) {
          this.savePhotoToBackend(image.url)
        }
      })
    },
    async onFile (event) {
      const limit = 10 - this.images.length
      const uploadedFiles = event.target.files.length

      if (limit - uploadedFiles < 0) {
        alert('Фотографий не может быть больше 10.')
        return
      }

      for (const image of event.target.files) {
        const base64File = await this.getBase64(image)

        this.images.push({
          id: Math.random(),
          url: base64File,
          fromBackend: false
        })
      }
    },
    async fetchInitialImages () {
      try {
        const { data } = await this.$api.field.photos(this.$route.params.id)

        this.images = data?.list.map(item => {
          return {
            id: item.id,
            url: item.url,
            fromBackend: true
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    onDeletePhoto ({ id, fromBackend }) {
      if (fromBackend) {
        this.deletedImages.push(id)
      }

      const index = this.images.findIndex(item => item.id === id)
      this.images.splice(index, 1)
    },
    async deleteFromBackend (id) {
      try {
        await this.$api.field.deletePhoto(this.$route.params.id, id)
      } catch (e) {
        console.log(e)
      }
    },
    async savePhotoToBackend (base64File) {
      const id = this.$route.params.id
      await this.$api.field.photoUpload(id, base64File)
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  .gallery {
    display: flex;
    margin-top: 24px;
    flex-wrap: wrap;

    &-item {
      margin-right: 20px;
      margin-bottom: 20px;
      width: 200px;
      position: relative;

      &__close {
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: red;
        cursor: pointer;
        user-select: none;
      }
    }
  }

  .panel {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
